// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class ChartSeriesDataConverter {
    constructor() {
        this._basisValue = 1;
    }
    get BasisValue() {
        return this._basisValue;
    }
    set BasisValue(value) {
        this._basisValue = value;
    }
    Calculate(originalValue) {
        return originalValue;
    }
    Revert(value) {
        return value;
    }
    static Convert(value, converter1, converter2) {
        if (converter1 === converter2) {
            return value;
        }
        let valueInAbs = value;
        if (converter1 !== null) {
            valueInAbs = converter1.Revert(value);
        }
        if (converter2 !== null) {
            return converter2.Calculate(valueInAbs);
        }
        else {
            return valueInAbs;
        }
    }
}
export class ChartSeriesRelativeDataConverter extends ChartSeriesDataConverter {
    Calculate(originalValue) {
        if (this.BasisValue === 0) {
            return 100;
        }
        else {
            return ((originalValue - this.BasisValue) / this.BasisValue) * 100;
        }
    }
    Revert(value) {
        return (value * this.BasisValue) / 100 + this.BasisValue;
    }
}
export class ChartSeriesLogDataConverter extends ChartSeriesDataConverter {
    constructor() {
        super(...arguments);
        this.LogBase = 2.71;
    }
    get BasisValue() {
        return this._basisValue;
    }
    set BasisValue(value) {
        this._basisValue = value <= 0 ? 0.0000001 : value;
    }
    Calculate(originalValue) {
        if (originalValue <= 0) {
            originalValue = 0.0000001;
        }
        return Math.log(originalValue / this.BasisValue) / Math.log(this.LogBase);
    }
    Revert(value) {
        return Math.pow(this.LogBase, value) * this.BasisValue;
    }
}
